<template>
  <menu-header>
    <ion-text class="font-bold ion-text-brand block text-center">
      <span :class="props.size == 'small' ? 'text-[16px]' : ''">{{ title }}</span>
    </ion-text>
  </menu-header>
</template>

<script setup>
import { computed } from 'vue';
import MenuHeader from '@/components/menu/MenuHeader.vue';
const props = defineProps(['title', 'size']);
const title = computed(() => props.title ? props.title : 'Security Details')
</script>